import api from './api.js';

/**
 * Fetch the bracket for a knockout competition (public)
 */
export async function getBracket(competitionId) {
  const response = await api.get(`/public/competitions/${competitionId}/bracket`);
  return response.bracket;
}

/**
 * Generate a bracket for a knockout competition (organizer only)
 */
export async function generateBracket(competitionId) {
  const response = await api.post(`/organizer/competitions/${competitionId}/bracket/generate`);
  return response.bracket;
}

/**
 * Generate a round-robin schedule for a league competition (organizer only)
 */
export async function generateSchedule(competitionId, { homeAndAway = false } = {}) {
  return await api.post(`/organizer/competitions/${competitionId}/schedule/generate`, {
    homeAndAway,
  });
}
